module.exports = __webpack_public_path__ + "static/media/icn_lightbox_prev.64310c74.svg";